// Imports
import { createGlobalStyle } from 'styled-components/macro';


// Define global style
const GlobalStyle = createGlobalStyle`
	html {
		min-height: 100%;
	}
	
	body {
		margin: 0;
		padding: 0;
		font-family: Inter, BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
		-moz-osx-font-smoothing: grayscale;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		text-size-adjust: 100%;
		font-variant-numeric: lining-nums;
		font-feature-settings:"lnum" 1;
		min-height: 100%;
		background: #fff;
		color: hsl(206, 25%, 20%);
		line-height: 1.2;
	}
	
	blockquote, body, dd, dl, dt, fieldset, figure, h1, h2, h3, h4, h5, h6, hr, html, iframe, legend, li, ol, p, pre, textarea, ul {
		margin: 0;
		padding: 0;
	}
	
	*:not(.svg-inline--fa) {
		box-sizing: border-box;
	}
`;

export default GlobalStyle;
